import CirclePerson from '../../src/legacy/CirclePerson';
export default CirclePerson;
